import React, { useCallback } from 'react';
import { ChangeHandler, useFormContext } from 'react-hook-form';
import { CheckboxPanel } from '@printdeal/ui-library';
import { Image } from '@unpic/react';

import { OptionProps } from './types/FileDesignTypes';
import {
  dispatchAccountEvent,
  DispatchCategoriesAccount,
} from '../../../../../../helpers/dataLayerHelpers/accountDataLayerHelper';

interface Props {
  fieldName: string;
  option: OptionProps;
  dispatchEventCategory?: DispatchCategoriesAccount;
}

const DesignOptionCheckbox = ({
  fieldName,
  option,
  dispatchEventCategory = 'order_detail_interaction',
}: Props) => {
  const {
    trigger,
    watch,
    setValue,
    register,
  } = useFormContext();

  const fieldValue = watch(fieldName);
  const objectRegistration = register(`${fieldName}Object.${option.title}`);

  const handleOnChange:ChangeHandler = useCallback(async (event) => {
    const onChangeOptions = {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    };

    if (fieldValue.includes(option.title)) {
      setValue(fieldName, fieldValue.filter((value:string) => value !== option.title), onChangeOptions);
    } else {
      setValue(fieldName, [...fieldValue, option.title], onChangeOptions);
    }

    objectRegistration.onChange(event);
    trigger(`${fieldName}Object.${option.title}`, { shouldFocus: true });

    dispatchAccountEvent(dispatchEventCategory, 'file_design_field_interaction - click', { fieldName });
  }, [dispatchEventCategory, fieldName, fieldValue, objectRegistration, option.title, setValue, trigger]);

  return (
    <CheckboxPanel
      key={option.title}
      id={`${fieldName}.${option.title}`}
      {...objectRegistration}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => { handleOnChange(e); }}
    >
      <Image alt={option.title} aspectRatio={1} src={option.url} objectFit="cover" width={160} />
      {option.title}
    </CheckboxPanel>
  );
};

export default DesignOptionCheckbox;
